/* eslint-disable arrow-body-style */
import React, { useCallback, useContext, useEffect, useRef } from 'react';
import classNames from 'classnames';
import $ from 'jquery';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { OverviewPagePhase2 } from '@bingads-webui-campaign-react/overview';
import state from '@bingads-webui-component-legacy/state/index';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { getRoutePathById, withSiteMap, processorSet, processor } from '@bingads-webui-react/with-site-map';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useCurrentCampaign } from '@bingads-webui-campaign-react/use-current-scope-entity';
import { getCampaignPageUrl } from '@bingads-webui-campaign-react/shared-app-capi';
import {
  getConversionTrackingCardStyle,
  metricPickerStyle,
} from '@bingads-webui-campaign-react/overview-card-styles';
import { useAssetGroupsData } from '@bingads-webui-campaign-react/asset-performance-card';
import { ManageAccountMenu } from './manage-account-menu';
import { SDKBottomBar } from './bottom-bar';
import { useNavigateToConverstionGoalCreationWorkflow } from './manage-conversion-alert-dialog/use-navigate-to-conversion-goal-creation-workflow';

const getStyles = palette => ({
  sdkCampaignOverviewPage: {
    '& .ba-overview-page': {
      maxWidth: 'none',
      '& .pmax-overview-page': {
        margin: '0 33px 14px 33px',
        padding: '0 6px',
      },
      '& .ba-performance-card-fluent-v2': {
        '& .ba-performance-card-metric-picker': {
          '& .ba-pc-metric-picker-item': {
            maxWidth: 160,
          },
        },
      },
    },
    '& .overview-card-container': {
      '& .view-all-clickLink button.btn': {
        border: '1px solid #D1D1D1',
        borderRadius: 4,
      },
      '&.overview-card-container-small': {
        width: '50%',
      },
      '&.navigate-to-full-product': {
        '&>.fui-FluentProvider, & .sdk-navigate-to-full-product': {
          height: '100%',
          paddingBottom: 8,
        },
      },
    },
  },
  '@global': {
    '& .app-shell-tab': {
      padding: '0 43px',
    },
    '& .bingads-campaign-react-tab-bar': {
      marginLeft: 0,
      '& .subPageMenu-singleItem': {
        paddingLeft: 0,
      },
    },
    '& #main': {
      display: 'flex',
      zIndex: 1032,
      flexDirection: 'column',
      overflow: 'auto',
      '& .app-content-container-grid, & .app-content-container-row, & .app-shell-content': {
        display: 'block',
      },
      '& .app-shell-content': {
        overflow: 'visible',
      },
      '& .performance-card .performance-card-metrics-picker .performance-card-metrics-picker__metric': {
        minWidth: 160,
        width: 'auto',
      },
    },
    '& .overview-card-backbone-instance .conversion-tracking-card': {
      height: '100%',
      '& .conversion-tracking-state div.carousel-footer, & .conversion-empty-state': {
        paddingBottom: 0,
      },
      '& .ms-Button.ms-Button--default': {
        border: '1px solid #D1D1D1',
        borderRadius: 4,
      },
    },
    ...metricPickerStyle,
    ...getConversionTrackingCardStyle(palette),
  },
});


const useEventBinding = ({ siteMap, rootNodeRef }) => {
  const { scope } = useContext(ScopeContext);
  const serverContext = useContext(ServerContext);

  const onLocationViewAllButtonClick = useCallback(() => {
    const route = getRoutePathById(siteMap, 'sdk-target-settings');
    scope.save(route);
  }, [siteMap, scope]);
  const onManageConversionGoalsClick = useCallback(() => {
    // Filter update should be conducted before open the url
    setTimeout(() => {
      const conversionGoalsGridUrl = getCampaignPageUrl(serverContext, 'conversiongoals');
      window.open(conversionGoalsGridUrl);
    });
  }, [serverContext]);
  const navigateToConverstionGoalCreationWorkflow = useNavigateToConverstionGoalCreationWorkflow();

  useEffect(() => {
    const rootNode = rootNodeRef.current;
    if (rootNode) {
      $(rootNode).on('click', '.view-all-clickLink', onLocationViewAllButtonClick);
      $(rootNode).on('click', '.conversion-tracking-card .action-button .ms-Button', onManageConversionGoalsClick);
      $(document.body).on('click', '.popover-content .see-all-link', onManageConversionGoalsClick);
      $(rootNode).on('click', '.conversion-goals-grid .conversion-goals-entity-name a', onManageConversionGoalsClick);
      $(rootNode).on('click', '.conversion-tracking-card .conversion-empty-state .entity-links .ms-Button', navigateToConverstionGoalCreationWorkflow);
    }

    return () => {
      $(rootNode).off('click', '.view-all-clickLink', onLocationViewAllButtonClick);
      $(rootNode).off('click', '.conversion-tracking-card .action-button .ms-Button', onManageConversionGoalsClick);
      $(document.body).off('click', '.popover-content .see-all-link', onManageConversionGoalsClick);
      $(rootNode).off('click', '.conversion-goals-grid .conversion-goals-entity-name a', onManageConversionGoalsClick);
      $(rootNode).off('click', '.conversion-tracking-card .conversion-empty-state .entity-links .ms_button', navigateToConverstionGoalCreationWorkflow);
    };
  }, [navigateToConverstionGoalCreationWorkflow, onLocationViewAllButtonClick, onManageConversionGoalsClick, rootNodeRef]);
  useEffect(() => {
    $('.app-shell-topBanner').on('click', '.setup-conversion-tracking-action', () => {
      navigateToConverstionGoalCreationWorkflow();
    });
    return () => {
      $('.app-shell-topBanner').off('click', '.setup-conversion-tracking-action');
    };
  }, [navigateToConverstionGoalCreationWorkflow]);
};

const useFirstAssetGroup = () => {
  const { scope } = useContext(ScopeContext);
  const { assetContainers } = useAssetGroupsData();
  if (!_.isEmpty(assetContainers) && scope.values.assetGroupId == null) {
    const firstAssetGroup = _.first(assetContainers);
    scope.append({ assetGroupId: firstAssetGroup.Id });
    scope.history.replace({
      pathname: scope.history.location.pathname,
      search: scope.stringify(),
    });
    return firstAssetGroup;
  }
  return null;
};

const SDKCampaignOverviewPageInternal = React.memo((props) => {
  const {
    siteMap,
  } = props;

  const { scope } = useContext(ScopeContext);
  const {
    campaignId,
  } = scope.values;
  if (campaignId) {
    state.set('campaign_id', campaignId);
  }
  const classes = useDefaultStyles(getStyles);
  const rootNodeRef = useRef(null);
  useEventBinding({ rootNodeRef, siteMap });

  const currentCampaign = useCurrentCampaign();

  useFirstAssetGroup();

  return (
    <div ref={rootNodeRef} className={classNames(classes.sdkCampaignOverviewPage, 'sdk-campaign-overview-page')}>
      <FluentProvider theme={webLightTheme}>
        <OverviewPagePhase2 {...props} currentCampaign={currentCampaign} isSDK />
        <SDKBottomBar />
        <ManageAccountMenu />
      </FluentProvider>
    </div>
  );
});

SDKCampaignOverviewPageInternal.propTypes = {
  preferenceService: PropTypes.shape({}).isRequired,
  siteMap: PropTypes.shape({}).isRequired,
};

export const SDKCampaignOverviewPage = withSiteMap(SDKCampaignOverviewPageInternal, [processor.processPath, ...processorSet.basic]);
